<section class="exam-loading-shell flex min-h-screen flex-col bg-slate-50 text-text-primary">
  <header class="border-b border-slate-200 bg-white">
    <div class="flex min-h-14 items-center justify-between gap-4 px-4 py-3 sm:px-6">
      <div class="flex items-center gap-0.5 px-2">
        <img [src]="imageEnum.COMPANY_LOGO_BLUE" alt="Charaka" class="h-8 w-8" />
        <h1 class="text-brand-primary text-4xl font-semibold tracking-wide font-serif">haraka</h1>
      </div>

      <div class="flex flex-wrap items-center justify-end gap-2 text-right">
        <p class="sub-paragraph m-0 text-text-secondary">Dr. {{ candidateName() | titleCase }}</p>
      </div>
    </div>
  </header>

  <main class="flex min-h-0 flex-1 items-center bg-[#F2F3F6] justify-center overflow-hidden px-4 py-8 sm:px-6">
    <div class="exam-loading-stage flex w-full items-center justify-center">
      <div class="exam-loading-background" aria-hidden="true">
        <img [src]="imageEnum.LOADER_BG_GIF" alt="" class="exam-loading-background-image" />
      </div>

      <section
        class="exam-loading-card relative z-10 w-full max-w-lg rounded-3xl bg-white px-8 py-2 shadow-xl sm:px-10 sm:py-4"
      >
        <div class="flex flex-col items-center text-center">
          @if (!isSubmitMode) {
            <div class="flex items-center gap-0.5 px-2 mt-2">
              <img [src]="imageEnum.COMPANY_LOGO_BLUE" alt="Charaka" class="h-8 w-8" />
              <h1 class="text-brand-primary text-4xl font-semibold tracking-wide font-serif">
                haraka
              </h1>
            </div>

            <h1 class="exam-heading font-inter">{{ screenData.heading }}</h1>
            <p class="sub-paragraph mt-3 text-text-secondary font-inter">{{ screenData.description }}</p>
          }

          
          @if (isSubmitMode) {
            <div class="flex items-center mt-2">
              <img [src]="imageEnum.PULSING" [alt]="isSaveProgressMode ? 'Saving progress' : 'Submitting responses'" class="h-20 w-20 " />
            </div>

            <h1 class="exam-heading font-inter text-2xl">{{ screenData.heading }}</h1>
            <p class="sub-paragraph text-base mt-2 text-text-secondary font-inter">{{ screenData.description }}</p>
          }

          <div class="mt-5 w-full">
            <div class="h-1.5 overflow-hidden rounded-full bg-slate-200">
              <div class="exam-progress-bar h-full rounded-full bg-brand-primary"></div>
            </div>
          </div>
          <p class="exam-status-text mt-4">{{ screenData.statusMessage }}</p>
        </div>
      </section>
    </div>
  </main>
</section>
